module.exports = __webpack_public_path__ + "static/img/banner3_04.c0f4cf4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner3_04.png
// module id = KpxC
// module chunks = 2